import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthSignalService } from '../services/auth-signal.service';

export const authGuard = () => {
  const router = inject(Router);
  const authService = inject(AuthSignalService);

  console.log('AuthGuard running with Signal Service');
  
  // Verificación directa del estado de autenticación usando Signals
  const isAuthenticated = authService.isAuthenticated();
  console.log('Authentication status in guard:', isAuthenticated);
  
  if (isAuthenticated) {
    console.log('User authenticated, proceeding');
    return true;
  } else {
    console.log('User not authenticated, redirecting to login');
    
    // Navegar a login con pequeño delay para asegurar que se complete
    setTimeout(() => {
      router.navigate(['/auth/login']);
    }, 50);
    
    return false;
  }
};